<template>
    <div class="tab-pane active">
        <app-button v-if="$store.getters.canEditUsers" native-type="button" type="success" class="float-right" @click="$modal.show('create_user')">
            {{ $t('Create') }}
        </app-button>
        <div class="clearfix"></div>
        <table class="table table-striped table-sm">
            <thead>
                <tr>
                    <th>#</th>
                    <th>{{ $t('Name') }}</th>
                    <th>{{ $t('Email') }}</th>
                    <th>{{ $t('Roles') }}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(user, i) in users" :key="i">
                    <td>{{ i + 1 }}</td>
                    <td>{{ user.name }}</td>
                    <td>{{ user.email }}</td>
                    <td>
                        <template v-for="role in user.roles">
                            {{ role.name }} <br :key="role.id">
                        </template>
                    <td class="p-0">
                        <div class="text-right">
                            <app-button v-if="$store.getters.canEditUsers" native-type="button" @click="$modal.show('update_user', {user})" small>
                                {{ $t('Edit') }}
                            </app-button>
                            <app-button v-if="$store.getters.canDeleteUsers" native-type="button" type="danger" @click="destroy(user.id)" small>
                                {{ $t('Delete') }}
                            </app-button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <create-modal @setUser="setUser"/>
        <update-modal @setUser="setUser"/>
    </div>
</template>

<script>
import UserService from '@services/user.service';
import CreateModal from './modals/Create';
import UpdateModal from './modals/Update';
import {mapGetters} from 'vuex';
import Vue from 'vue';

export default {
    data() {
        return {
            users: []
        };
    },
    computed: {
        ...mapGetters(['locale'])
    },
    methods: {
        getUsers() {
            UserService.users().then(res => this.users = res);
        },
        setUser(user) {
            const index = this.users.findIndex(r => r.id === user.id);
            if (index !== -1) {
                Vue.set(this.users, index, user);
            } else {
                this.users.push(user);
            }
        },
        destroy(userId) {
            if (!window.confirm(`${this.$t('Delete')}?`)) {
                return false;
            }
            UserService.destroy(userId).then(res => {
                const index = this.users.findIndex(r => r.id === userId);
                this.users.splice(index, 1);
                this.$toastr.s(this.$t('Deleted'));
            });
        }
    },
    components: {
        CreateModal,
        UpdateModal,
    },
    created() {
        this.getUsers();
    },
    metaInfo() {
        return {
            title: this.$t('Users')
        };
    }
};
</script>
